<template>
  <div class="pt-3 px-3 pb-1">
           
      <p v-if="users.length == 0" class="text-center">No clients</p>

        <span v-else >

       <!-- Desktop -->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Name</th>
                  <th>City</th>
                  <th>Country</th>
                  <th class="first-right">Registered</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" :key="index">
                    <td class="pl-3">{{ user.name }} {{ user.surname }}</td>
                    <td>{{ user.city }}</td>
                    <td><img 
                    v-if="user.country"
                    :src="'/images/flags/svg/'+getFlag(user.country)" 
                    class="country_flag mr-2" 
                    :title="user.city+' - '+user.country">{{ user.country }}</td>
                    <td><timeago
                    :datetime="user.created_at"
                    :auto-update="60"
                    :title="formatDateMoment(user.created_at)"></timeago></td>
                </tr>
              </tbody>
            </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Name • Country • Registered</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="index">
  
        <td class="pl-2">
            <div>{{ user.name }} {{ user.surname }}</div>
            <div>{{`${user.city} - ${user.country}`}}</div>
            <div><timeago
                  :datetime="user.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(user.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </span>

          </div>

</template>

<script>
export default {
  props: ['user'],

  data() {
    return {
      users: [],
      loading: false,
      balance_class: 'owing',
    };
  },

  created() {
    this.getUsers();

    Echo.private("clients_"+this.user.id)
      .listen("NewClient", (event) => {
        this.getUsers();
      });

  },

  methods: {
    openlink(id) {
      if (id) {
        window.open(`/accounts/view/${id}`, '_self');
      }
    },

    getUsers() {

      this.loading = true;

      axios
        .post('/accounts/affiliate', {
          user_id: this.user.id,
        })
        .then((response) => {
          this.users = response.data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

  },
};
</script> 

<style scoped>

</style>